const loginPopup = () => {
  document.addEventListener('DOMContentLoaded', function () {
    const closeBtn = document.querySelector('.login-popup-wrapper .close-btn');
    const loginPopupBlock = document.querySelector('.login-popup-wrapper');

    if (!loginPopupBlock) return;

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        loginPopupBlock.classList.add('hide-popup');
      });
    }
  });
};

export default loginPopup;
